import { memo } from "react";
import "./horizontal-dot-loader.scss";
import PropTypes from "prop-types";

const HorizontalDotLoader = ({ color = "#2B383F", dotSize = "6px" }) => {
	const dotStyle = {
		backgroundColor: color,
		height: dotSize,
		width: dotSize,
	};

	return (
		<div className="horizontal-dot-loader">
			<div className="horizontal-dot-loader__dot" style={dotStyle} />
			<div className="horizontal-dot-loader__dot" style={dotStyle} />
			<div className="horizontal-dot-loader__dot" style={dotStyle} />
		</div>
	);
};

HorizontalDotLoader.propTypes = {
	color: PropTypes.string,
	dotSize: PropTypes.string,
};

export default memo(HorizontalDotLoader);
